<template>
  <div class="template w-full">
    <car-type />
  </div>
</template>

<script>

import { mapMutations } from 'vuex'
import CarType from '../../components/offers/car-type.vue'

export default {

  components: {
    CarType
  },

  mounted() {
    if (!this.$route.query.source && (this.$route.query.source !== 'lead')) {
      this.storeCashSaleCustomer(null)
      this.storeLeadSource(null)
      this.storeLeadId(null)
    }

    this.storeCashSaleVehicle(null)
    this.storeCashSaleAccessories(null)
    this.storeCashSaleCalculation(null)
    this.storeCashSaleConfiguration(null)
    this.storeQuickMethod(null)
    this.storeOffer(null)
    this.storeFinancingDomain(null)
    this.storeFinancingProduct(null)
    this.storeFinancingVehicleEquipment(null)
    this.storeFinancingVehicle(null)

    eventBus.$emit('mia-loading-ended')
  },

  methods: {
    ...mapMutations([
      'storeCashSaleCustomer',
      'storeCashSaleVehicle',
      'storeCashSaleAccessories',
      'storeCashSaleCalculation',
      'storeCashSaleConfiguration',
      'storeQuickMethod',
      'storeOffer',
      'storeFinancingDomain',
      'storeFinancingProduct',
      'storeFinancingVehicleEquipment',
      'storeFinancingVehicle',
      'storeLeadSource',
      'storeLeadId'
    ])
  }
}

</script>
